import React, { useEffect, useState } from 'react';

import PageLayout from 'components/layouts/PageLayout';
import Text from 'components/commons/Text';

import LandmarkContainer from 'components/pages/listings/LandmarkContainer';
import { Row } from 'saladsoft-primitive';
import RecommendContainer from 'components/pages/listings/RecommendContainer';

const ListingLandmarkSettingsPage = () => {
  const PageTitle = () => {
    return (
      <Row gap="10px">
        <Text type="H2">주변 명소 및 추천한옥</Text>
      </Row>
    );
  };

  return (
    <PageLayout title={<PageTitle />}>
      <LandmarkContainer />
      <RecommendContainer />
    </PageLayout>
  );
};

export default ListingLandmarkSettingsPage;
